import ThemeProvider from "@ts-digital/vrc/es/components/theme-provider";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { APP_VERSION, BASE_PATH } from "../config";
import localStorage from "../core/common/localStorage";
import { initializeApp } from "../core/usecases/initializeApp";
import i18nMessages from "../i18n";
import LanguageProvider, { Locale } from "./components/LanguageProvider";
import WindowDimensionsProvider from "./components/WindowDimensionsProvider";
import "./index.css";
import { Root } from "./views/Root";

initializeApp();

export default function renderApp() {
    console.log("PAYMENT CONTAINER FRONT - ", APP_VERSION);

    const locale = localStorage.get("language") || Locale.ItIt;
    ReactDOM.render(
        <React.StrictMode>
            <ThemeProvider>
                <WindowDimensionsProvider>
                    <LanguageProvider
                        locale={locale}
                        messages={
                            locale === Locale.EnUs
                                ? i18nMessages.en
                                : i18nMessages.it
                        }
                    >
                        <BrowserRouter basename={BASE_PATH}>
                            <Root />
                        </BrowserRouter>
                    </LanguageProvider>
                </WindowDimensionsProvider>
            </ThemeProvider>
        </React.StrictMode>,
        document.getElementById("root")
    );
}
